import React from 'react';
import { formatMoney } from '../utils/money';

/**
 * <Money amount={12.5} currency="USD" />  →  $12.50
 * 仅展示：按记录自己的币种渲染，不换算。见 shared/utils/money.js
 */
const Money = ({ amount, currency, decimals = 2, empty = '-', negative = false, style, className }) => (
    <span style={style} className={className}>
        {formatMoney(amount, currency, { decimals, empty, negative })}
    </span>
);

export default Money;
